import { render, staticRenderFns } from "./widget-test.vue?vue&type=template&id=64e29f60&"
import script from "./widget-test.vue?vue&type=script&lang=js&"
export * from "./widget-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports